// @flow

import {fabric} from 'fabric';

import type {BiePluginType} from '../types';
import {CanvasManager} from '../managers/canvas-manager';
import colors from '../colors';

export class BieCropPlugin implements BiePluginType {
  overlay: fabric.Rect;

  setup() {}

  getActionButtons() {
    return [
      {
        type: 'enter-state',
        title: 'Crop',
        icon: 'fas fa-crop',
        slug: 'crop',
        component: 'div',
        enter: this.startCrop,
        cancel: this.cancelCrop,
        confirm: this.confirmCrop,
      },
    ];
  }

  cancelCrop(cm: CanvasManager) {
    cm.canvas.remove(this.overlay);
  }

  confirmCrop(cm: CanvasManager) {
    const rect = this.overlay.getBoundingRect();
    const image = new Image();
    cm.canvas.remove(this.overlay);
    image.src = cm.canvas.toDataURL({
      left: rect.left,
      top: rect.top,
      width: rect.width,
      height: rect.height,
    });
    image.width = rect.width;
    image.height = rect.height;

    cm.canvas.clear();
    cm.canvas.renderAll();
    cm.setImage(new fabric.Image(image));
  }

  startCrop(cm: CanvasManager) {
    this.overlay = new fabric.Rect({
      fill: colors.cropFill,
      strokeWidth: 0,
      left: 10,
      top: 10,
      opacity: 1,
      width: cm.img.get('width') / 2,
      height: cm.img.get('height') / 2,
      hasRotatingPoint: false,
      lockUniScaling: false,
    });

    cm.canvas
      .add(this.overlay)
      .centerObject(this.overlay)
      .setActiveObject(this.overlay);
  }
}
